import styled from "styled-components";

export const StyledAppBar = styled.header`
    padding: 40px 40px 10px 40px;
    background-color: ${({ theme }) => theme.colors.whiteSmoke};
`;

export const StyledAppBarWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
`;

export const StyledAppBarContent = styled.div`
    width: 100%;
`;